import React from 'react';
import { motion } from 'framer-motion';
const costs = [{
  without: 'Semanas con dolor sin protocolo',
  cost: 'Grietas, mastitis, abandono evitable'
}, {
  without: 'Brotes sin mapa',
  cost: 'Suplementación innecesaria que destruye la producción'
}, {
  without: 'Sin tracker ni datos',
  cost: 'Consultas pediátricas sin información — decisiones en el vacío'
}, {
  without: 'Mitos del entorno sin filtro',
  cost: 'Decisiones tomadas desde información incorrecta'
}, {
  without: 'Noches de 3 AM sin protocolo',
  cost: 'Agotamiento acumulado que pone en riesgo todo'
}];
export function CostComparison() {
  return <section className="py-20 px-4 bg-brand-darker" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-35">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light" data-id="element-36">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-dark rounded-2xl border border-brand-primary/20 overflow-hidden" data-id="element-37">
          <div className="overflow-x-auto" data-id="element-38">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-39">
              <thead data-id="element-40">
                <tr className="bg-brand-darker border-b border-brand-primary/20" data-id="element-41">
                  <th className="p-6 text-brand-primary font-medium w-1/2 text-lg" data-id="element-42">
                    Sin el Pack
                  </th>
                  <th className="p-6 text-red-400 font-medium w-1/2 text-lg" data-id="element-43">
                    El costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-44">
                {costs.map((row, i) => <tr key={i} className="border-b border-brand-primary/10 last:border-0" data-id="element-45">
                    <td className="p-6 text-brand-cream-light font-medium" data-id="element-46">
                      {row.without}
                    </td>
                    <td className="p-6 text-brand-primary/80" data-id="element-47">{row.cost}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}